export function getDirections(locationId: string, placeId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/directions?placeId=${placeId}`,
  }
}
